"use strict";
var cookieconsent = localStorage.getItem('cookieconsent-dismissed-3');
if (!cookieconsent) {
    var consentBanner = document.getElementById('consent-banner');
    if (consentBanner) {
        consentBanner.style.display = 'block';
    }
}
var dismissButtons = document.querySelectorAll('#consent-banner .got-it');
document.querySelectorAll('#consent-banner .got-it').forEach(function (dismissButton) {
    dismissButton.addEventListener('click', function () {
        localStorage.setItem('cookieconsent-dismissed-3', "true");
        var consentBanner = document.getElementById('consent-banner');
        if (consentBanner) {
            consentBanner.style.display = 'none';
        }
    });
});
function waitForElmSmile(selector) {
    // @ts-ignore
    return new Promise(function (resolve) {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        var observer = new MutationObserver(function (mutations) {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
waitForElmSmile('#smile-ui-lite-container').then(function () {
    var smileContainer = document.getElementById('smile-ui-lite-container');
    if (smileContainer) {
        smileContainer.style.zIndex = "2147483643";
    }
});
waitForElmSmile('#shopify-chat').then(function () {
    var chatContainer = document.getElementById('shopify-chat');
    if (chatContainer) {
        chatContainer.style.zIndex = "2147483643";
        chatContainer.style.position = "relative";
    }
});
